module.exports = __webpack_public_path__ + "newsletter/Components/PocketHitsSignup/images/publishers/logo-outside.caceae38dae39eb0fd97561adb9ec329.png";